export const POLICY_NOTES_ACTION = 'POLICY_NOTES_ACTION';
export const POLICY_NOTES_SUCCESS_ACTION = 'POLICY_NOTES_SUCCESS_ACTION';
export const POLICY_NOTES_FAILURE_ACTION = 'POLICY_NOTES_FAILURE_ACTION';
